import * as Yup from 'yup'

export const AddSingleMCPaymentSchema = Yup.object().shape({
  masterContractorExternalId: Yup.string().required('Master contractor is required'),
  amount: Yup.string().required('Amount is required').min(6, 'Amount is invalid'),
})
